<ng-container *ngIf="numOfAddlAccounts>0" [attr.data-qa]="'additional-acccounts-container'">
  <div class="container">
    <h2 class="my-3" [attr.data-qa]="'additional-acccounts-title'">Additional Accounts</h2>
    <div class="product-box col-xs-12 pt-4 pb-4">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4">
        <p [attr.data-qa]="'additional-acccounts-p'">For ease of access, here are additional link(s) associated with your retirement account.</p>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-8">
        <ul class="list-unstyled ac-list m-0" [attr.data-qa]="'additional-acccounts-list'">
          <li class="col-xs-12 col-sm-6 col-md-6 mb-3 pl-0" *ngFor="let ac of AddlAccounts"><a [attr.data-qa]="'additional-acccounts-acctName-link'" [href]="ac.ACurl" target="_blank" rel="noopener noreferrer"><span class="d-inline-block">{{ac.acctName}}<span class="sr-only"> opens in new window</span></span></a></li>
        </ul>
        </div>
    </div>
    </div>
  </div>
</ng-container>
